<div class="legal-container noscrollbar" [ngClass]="rootClassName">
   <div class="legal-content-container">
    @if (isModal && isWeb) {
      <pop-ui-navigationbar class="legal-navigationbar" [(state)]="navigationState"></pop-ui-navigationbar>
    }
    <div id="legal-content" class="legal-content">
      <div class="legal-table">
        @switch (legal) {
          @case ('tacos') { <pop-ui-legal-tacos></pop-ui-legal-tacos> }
          @case ('privacy') { <pop-ui-legal-privacy></pop-ui-legal-privacy> }
          @case ('unsubscribe') { <pop-ui-legal-unsubscribe></pop-ui-legal-unsubscribe> }
          @case ('cookie') { <pop-ui-cookie-banner></pop-ui-cookie-banner> }
        }
      </div>
      <div class="frame40pxspacer"></div>
    </div>
  </div>
</div>
